export class Chetra {
  id: number;
  name: string;
  description: string;
  pradeshSabhaId: number;
  chetraCode: string;
  pradeshSabhaName: string;
}
